import type { BusinessType, SettlementFormData } from './types';

export const SETTLEMENT_FORM_SCHEMA = {
  validationMode: 'onTouched' as const,

  businessTypeOptions: [
    { label: '개인', value: 'NATURAL_PERSON' as BusinessType },
    { label: '개인 사업자', value: 'SOLO_PROPRIETORSHIP' as BusinessType },
    { label: '법인 사업자', value: 'LEGAL_ENTITY' as BusinessType },
  ],

  validation: {
    idNumber: {
      firstMaxLength: 6,
      secondMaxLength: 7,
    },
    businessRegistrationNumber: {
      maxLength: 12,
    },
  },

  ui: {
    tooltipDisplayDuration: 5000, // 5초
  },
} as const;

export const getSettlementFormDefaults = (
  overrides?: Partial<SettlementFormData>,
): SettlementFormData => ({
  businessType: 'NATURAL_PERSON',
  idNumberFirst: '',
  idNumberSecond: '',
  identityFile: null,
  businessName: '',
  businessRegistrationNumber: '',
  businessLicenseFile: null,
  bankName: '',
  accountNumber: '',
  accountHolder: '',
  isAccountVerified: false,
  accountCopyFile: null,
  termsAgreed: false,
  ...overrides,
});
